import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  {
    image: 'https://readdy.ai/api/search-image?query=Saudi%20Arabia%20warm%20golden%20hour%20aerial%20cityscape%20Madinah%20Al%20Munawwarah%20beautiful%20architecture%20minarets%20soft%20light%20serene%20inspiring%20landscape%20wide%20shot&width=1600&height=900&seq=311&orientation=landscape',
    tag: 'منصة موثوقة ومرخصة',
    title: 'ادعم الأحلام',
    highlight: 'غيّر الحياة',
    sub: 'منصة هِبة تربطك بالمبدعين وأصحاب القضايا في المملكة. ادعم بثقة، وابدأ حملتك بسهولة.',
    accent: '#10b981',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Saudi%20young%20entrepreneur%20creative%20workspace%20modern%20minimalist%20warm%20tones%20laptop%20notebook%20startup%20success%20confident%20professional&width=1600&height=900&seq=312&orientation=landscape',
    tag: 'للمبدعين والرواد',
    title: 'حوّل فكرتك',
    highlight: 'إلى واقع',
    sub: 'آلاف المبدعين أطلقوا مشاريعهم عبر هِبة وحققوا أحلامهم. انضم إليهم اليوم.',
    accent: '#f59e0b',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Saudi%20Arabia%20community%20people%20gathering%20helping%20charity%20warm%20golden%20light%20unity%20togetherness%20hope%20inspiring%20authentic&width=1600&height=900&seq=313&orientation=landscape',
    tag: 'تكافل وعطاء',
    title: 'معاً نصنع',
    highlight: 'الفرق',
    sub: 'كل ريال تتبرع به يصنع أثراً حقيقياً في حياة إنسان. كن جزءاً من قصة نجاح.',
    accent: '#10b981',
  },
];

const stats = [
  { value: '+2,000', label: 'حملة ناجحة', icon: 'ri-flag-line' },
  { value: '+50K',   label: 'داعم كريم',   icon: 'ri-user-heart-line' },
  { value: '30M+',   label: 'ريال جُمع',   icon: 'ri-money-dollar-circle-line' },
  { value: '89%',    label: 'نسبة النجاح', icon: 'ri-bar-chart-line' },
];

const HeroSection = () => {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % slides.length);
        setAnimating(false);
      }, 400);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  const goTo = (i: number) => {
    if (i === current) return;
    setAnimating(true);
    setTimeout(() => { setCurrent(i); setAnimating(false); }, 300);
  };

  const slide = slides[current];

  return (
    <section className="relative min-h-screen flex flex-col overflow-hidden" dir="rtl">

      {/* ── Background Images ── */}
      {slides.map((s, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-1000"
          style={{ opacity: i === current ? 1 : 0 }}
        >
          <img src={s.image} alt="" className="w-full h-full object-cover object-top" />
        </div>
      ))}

      {/* ── Overlays ── */}
      <div className="absolute inset-0 bg-gradient-to-l from-black/80 via-black/55 to-black/20"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

      {/* ── Main Content ── */}
      <div className="relative z-10 flex-1 flex items-center w-full max-w-7xl mx-auto px-6 md:px-12 pt-28 pb-10">
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* Left: Text */}
          <div
            style={{
              opacity: animating ? 0 : 1,
              transform: animating ? 'translateY(16px)' : 'translateY(0)',
              transition: 'opacity 0.4s ease, transform 0.4s ease',
            }}
          >
            {/* Tag */}
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-4 py-1.5 mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse shrink-0"></span>
              <span className="text-white/90 text-xs font-medium tracking-wide">{slide.tag}</span>
            </div>

            {/* Title */}
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-[1.1] mb-5">
              {slide.title}
              <br />
              <span
                className="relative inline-block"
                style={{ color: slide.accent }}
              >
                {slide.highlight}
                <span
                  className="absolute bottom-1 right-0 left-0 h-1 rounded-full opacity-40"
                  style={{ background: slide.accent }}
                ></span>
              </span>
            </h1>

            {/* Subtitle */}
            <p className="text-white/75 text-base md:text-lg leading-relaxed mb-8 max-w-lg">
              {slide.sub}
            </p>

            {/* CTAs */}
            <div className="flex flex-wrap gap-3 mb-10">
              <Link
                to="/explore"
                className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-bold px-7 py-3.5 rounded-full transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
                style={{ boxShadow: '0 0 24px rgba(16,185,129,0.35)' }}
              >
                <i className="ri-compass-3-line text-base"></i>
                استكشف الحملات
              </Link>
              <Link
                to="/create"
                className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/25 text-white font-bold px-7 py-3.5 rounded-full transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-add-circle-line text-base"></i>
                ابدأ حملتك
              </Link>
            </div>

            {/* Slide Dots */}
            <div className="flex items-center gap-2">
              {slides.map((_, i) => (
                <button
                  key={i}
                  onClick={() => goTo(i)}
                  className="cursor-pointer transition-all duration-300"
                  style={{
                    width: i === current ? 28 : 8,
                    height: 8,
                    borderRadius: 99,
                    background: i === current ? slide.accent : 'rgba(255,255,255,0.3)',
                  }}
                />
              ))}
              <span className="text-white/40 text-xs mr-2">
                {current + 1} / {slides.length}
              </span>
            </div>
          </div>

          {/* Right: Stats Cards */}
          <div className="hidden lg:grid grid-cols-2 gap-4">
            {stats.map((stat, i) => (
              <div
                key={i}
                className="bg-white/10 backdrop-blur-md border border-white/15 rounded-2xl p-5 hover:bg-white/15 transition-all duration-300"
                style={{
                  opacity: animating ? 0 : 1,
                  transform: animating ? 'translateY(12px)' : 'translateY(0)',
                  transition: `opacity 0.4s ease ${i * 60}ms, transform 0.4s ease ${i * 60}ms`,
                }}
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/10 mb-3">
                  <i className={`${stat.icon} text-emerald-400 text-lg`}></i>
                </div>
                <div className="text-2xl font-black text-white mb-0.5">{stat.value}</div>
                <div className="text-white/60 text-xs">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Bottom Bar ── */}
      <div className="relative z-10 w-full border-t border-white/10 bg-black/20 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-4">
          {/* Mobile: stats centered in 2x2 grid */}
          <div className="grid grid-cols-2 gap-x-6 gap-y-3 lg:hidden">
            {stats.map((stat) => (
              <div key={stat.label} className="flex items-center gap-2 justify-center">
                <i className={`${stat.icon} text-emerald-400 text-sm`}></i>
                <span className="text-white font-black text-sm">{stat.value}</span>
                <span className="text-white/50 text-xs">{stat.label}</span>
              </div>
            ))}
          </div>
          <div className="hidden lg:flex items-center justify-between">
            <div className="flex items-center gap-6">
              {[
                { icon: 'ri-shield-check-line', text: 'منصة مرخصة رسمياً' },
                { icon: 'ri-bank-line', text: 'تحويل آمن ومشفر' },
                { icon: 'ri-customer-service-2-line', text: 'دعم على مدار الساعة' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2 text-white/60 text-xs">
                  <i className={`${item.icon} text-emerald-400`}></i>
                  {item.text}
                </div>
              ))}
            </div>
            {/* Scroll hint */}
            <div className="flex items-center gap-2 text-white/40 text-xs">
              <span>تمرر للاستكشاف</span>
              <i className="ri-arrow-down-line animate-bounce"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
